import React from "react";

const Stock_Ticker = ({ resultMetaData: { stock__ticker } }) => {
  return <div className={"stock-ticker"}>{stock__ticker}</div>;
};

export default Stock_Ticker;
